import { render, staticRenderFns } from "./audioView.vue?vue&type=template&id=384e3b96"
import script from "./audioView.vue?vue&type=script&lang=ts"
export * from "./audioView.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports